import { mapParamsBySchema, mapRowsBySchema } from '../../../util';
import { apiRequest } from '../../../Services/Common/ApiRequest';
import Global from '../../../Services/Common/Global';
import { M_PPE_BASIC_Schema } from './M_PPE_BASIC_Schema';
import useSaveMutation from '../../../Hooks/apis/useSaveMutaion';
import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { handleQuerySuccess } from '../../../Hooks/apis/useQuriesSuccess';

/** 보호구 조회(PPE) GetEquipIssueR2 */
export const useSearch1 = (options = {}) => {
  const { onSuccess } = options;
  const params = mapParamsBySchema(M_PPE_BASIC_Schema.mapper.search1);

  const query = useQuery({
    queryKey: ['PPE', 'getEquipIssueR2', params],
    queryFn: () => apiRequest('post', Global.urls.WorkStart.getEquipIssueR2, params),
    enabled: true,
  });

  useEffect(() => {
    if (!query.isSuccess) return;

    handleQuerySuccess(query.data, {
      onSuccess: async (rows) => {
        await onSuccess?.(rows);
      },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [query.isSuccess, query.dataUpdatedAt]);

  return query;
};

/** 보호구 체크 여부 저장 SaveEquipLogU1 */
export const useSave1 = (options = {}) => {
  return useSaveMutation(async (rows) => {
    const payload = mapRowsBySchema(
      rows,
      M_PPE_BASIC_Schema.mapper.save1
    );
    return apiRequest('post1', Global.urls.WorkStart.saveEquipLogU1, payload);
  }, options);
};
